import {createBudget} from 'core/Budget';
import {createHistory} from 'core/History';
import {calcDailyBudget} from 'core/DailyBudget';
import {createMoneyBox} from 'core/MoneyBox';
import {createSettings, DEFAULT_IS_REFILL_ENABLED} from 'core/Settings';
import {
  DEFAULT_BUDGET_AMOUNT as defaultAmount,
  DEFAULT_BUDGET_DAYS_COUNT as defaultDaysCount,
} from 'shared/const';

export function init(
  amount: MoneyAmount = defaultAmount,
  daysCount: DaysCount = defaultDaysCount,
  isRefillEnabled: boolean = DEFAULT_IS_REFILL_ENABLED
): CoreState {
  const budget: Budget = createBudget(amount, daysCount);
  const history: HistoryLog = createHistory();
  const dailyBudget: DailyBudget = calcDailyBudget(budget, history);
  const moneyBox: MoneyBox = createMoneyBox();
  const settings: Settings = createSettings(isRefillEnabled);

  return {
    budget,
    history,
    dailyBudget,
    moneyBox,
    settings,
  };
}
